import { afterNextRender, ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

const COOKIE_CONSENT_STORAGE_KEY = 'dmp-cookie-consent-v1';

@Component({
  selector: 'app-data-collection-notice',
  imports: [RouterLink],
  templateUrl: './data-collection-notice.component.html',
  styleUrl: './data-collection-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataCollectionNoticeComponent {
  protected readonly visible = signal(false);
  protected readonly expanded = signal(false);

  constructor() {
    afterNextRender(() => {
      try {
        this.visible.set(localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) !== 'accepted');
      } catch {
        this.visible.set(true);
      }
    });
  }

  protected accept(): void {
    this.visible.set(false);

    try {
      localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'accepted');
    } catch {
      // В браузерах с отключённым хранилищем уведомление скроется до перезагрузки страницы.
    }
  }

  protected toggleDetails(): void {
    this.expanded.update((value) => !value);
  }
}
